<template lang='pug'>
  el-dialog(title="请设置今天的目标", :visible.sync="visible")
    el-form(label-width="100px")
      el-form-item(label='关键指标:')
        b {{goal}}量
      el-form-item(label='今天任务量:')
        el-input-number(v-model="goalNum" :min="0")
    div(style="margin-bottom:5px;")
      b 常规分解目标(每天)：
    el-table(:data="normalGoal" border style="width: 100%")
      el-table-column(v-for="h,k in goalHead" :prop="h" :label="h" :key="k" width="110")
    span(slot="footer")
      el-button(@click="cancel") 取消
      el-button(@click="submit", type="primary") 确认
</template>

<script>
// Generated by CoffeeScript 2.3.0
var dateFormat, m;

dateFormat = require('dateformat');

export default m = {
  data: function() {
    return {
      visible: false,
      goal: '',
      goalNum: 0,
      goalHead: [],
      normalGoal: []
    };
  },
  methods: {
    show: function() {
      var ng, today;
      today = dateFormat(new Date(), 'yyyy-mm-dd');
      this.goal = app.user.goal || '电话';
      if (app.user.goal_date === today) {
        this.goalNum = app.user.goal_num;
      }
      if (app.user['类型'] === '前端') {
        this.goalHead = ['电话', '会面', '线人', '变动', 'BD-Leads', 'Mapping', '薪酬', 'LIST'];
      } else {
        this.goalHead = ['电话', '推荐', '面试', '变动', 'offer', '到岗', 'BD-Leads', 'LIST'];
      }
      ng = {
        '电话': parseInt(app.user['电话'] || 0),
        '推荐': (parseInt(app.user['推荐'] || 0) / 5).toFixed(2),
        '面试': (parseInt(app.user['面试'] || 0) / 5).toFixed(2),
        'offer': (parseInt(app.user['offer'] || 0) / 22).toFixed(2),
        '到岗': (parseInt(app.user['到岗'] || 0) / 22).toFixed(2),
        'LIST': (parseInt(app.user['LIST'] || 0) / 22).toFixed(2),
        '变动': (parseInt(app.user['变动'] || 0) / 5).toFixed(2),
        '会面': (parseInt(app.user['会面'] || 0) / 5).toFixed(2),
        '线人': (parseInt(app.user['线人'] || 0) / 5).toFixed(2),
        'BD-Leads': (parseInt(app.user['BD-Leads'] || 0) / 5).toFixed(2),
        'Mapping': (parseInt(app.user['Mapping'] || 0) / 5).toFixed(2),
        '薪酬': (parseInt(app.user['薪酬'] || 0) / 5).toFixed(2)
      };
      this.normalGoal = [ng];
      return this.visible = true;
    },
    hide: function() {
      return this.visible = false;
    },
    cancel: function() {
      return this.hide();
    },
    submit: function() {
      var today;
      if (this.goalNum) {
        today = dateFormat(new Date(), 'yyyy-mm-dd');
        return app.service('users').patch(app.user._id, {
          goal_date: today,
          goal_num: this.goalNum
        }).then((res) => {
          app.user.goal_date = today;
          app.user.goal_num = this.goalNum;
          this.$message({
            type: 'success',
            message: '设置成功'
          });
          return this.cancel();
        });
      } else {
        return this.$message({
          type: 'info',
          message: '请填写任务量'
        });
      }
    }
  }
};
</script>

